// Typed GraphQL documents for the provider-neutral calendar settings page.
// This module must never reference legacy Cronofy mutations
// (createCronofyFeed / removeCronofyProfile / updateCronofyCalendars /
// updateCronofyClient) — those remain for old clients only.

export const CALENDAR_INTEGRATION_STATUS_QUERY = `
  query CalendarIntegrationStatus {
    calendarIntegrationStatus {
      calendarConnected
      cronofyConnected
      calendarBackendState
      connectableProviders
      connections {
        publicId
        provider
        implementation
        status
        migrationState
        displayIdentity
        lastSyncedAt
        lastErrorAt
        linkedConnectionPublicId
        calendars {
          id
          displayName
          mailboxContext
          providerPrimary
          readable
          writable
          selectedForConflicts
          selectedForWrite
        }
        routes {
          capability
          mode
          effectiveAt
        }
        canResyncBookings
        canCompleteReconnectMigration
        canRefreshMirror
        mirrorRefreshRateLimited
        syncActivity {
          state
          messageKey
          pendingOperationsCount
        }
      }
      migrations {
        migrationId
        state
        stats
        correlationId
        sourceConnectionPublicId
        destinationConnectionPublicId
        blockers {
          code
          count
        }
      }
    }
  }
`

export const UPDATE_CALENDAR_CONFLICT_SELECTIONS_MUTATION = `
  mutation UpdateCalendarConflictSelections($connectionPublicId: String!, $calendarIds: [ID!]!) {
    updateCalendarConflictSelections(connectionPublicId: $connectionPublicId, calendarIds: $calendarIds) {
      result
      errors
    }
  }
`

export const UPDATE_CALENDAR_WRITE_SELECTIONS_MUTATION = `
  mutation UpdateCalendarWriteSelections($connectionPublicId: String!, $calendarIds: [ID!]!) {
    updateCalendarWriteSelections(connectionPublicId: $connectionPublicId, calendarIds: $calendarIds) {
      result
      errors
    }
  }
`

export const DISCONNECT_CALENDAR_CONNECTION_MUTATION = `
  mutation DisconnectCalendarConnection($connectionPublicId: String!) {
    disconnectCalendarConnection(connectionPublicId: $connectionPublicId) {
      result
      errors
    }
  }
`

export const CONNECT_APPLE_CALENDAR_MUTATION = `
  mutation ConnectAppleCalendar($appleId: String!, $appSpecificPassword: String!) {
    connectAppleCalendar(appleId: $appleId, appSpecificPassword: $appSpecificPassword) {
      result
      errors
      connectionPublicId
      displayIdentity
    }
  }
`

export const CONNECT_ICAL_FEED_MUTATION = `
  mutation ConnectIcalFeed($feedUrl: String!) {
    connectIcalFeed(feedUrl: $feedUrl) {
      result
      errors
      connectionPublicId
      displayIdentity
    }
  }
`

export const START_CALENDAR_MIGRATION_MUTATION = `
  mutation StartCalendarMigration($connectionPublicId: String!, $dryRun: Boolean!) {
    startCalendarMigration(connectionPublicId: $connectionPublicId, dryRun: $dryRun) {
      result
      errors
      migrationId
      state
    }
  }
`

export const START_CALENDAR_CUTOVER_MUTATION = `
  mutation StartCalendarCutover($connectionPublicId: String!, $dryRun: Boolean!) {
    startCalendarCutover(connectionPublicId: $connectionPublicId, dryRun: $dryRun) {
      result
      errors
      status
      blockers {
        code
        count
      }
    }
  }
`

export const RESYNC_CALENDAR_MANAGED_EVENTS_MUTATION = `
  mutation ResyncCalendarManagedEvents($connectionPublicId: String!) {
    resyncCalendarManagedEvents(connectionPublicId: $connectionPublicId) {
      result
      errors
      enqueued
      restoredRemote
      skipped
    }
  }
`

export const COMPLETE_CALENDAR_RECONNECT_MIGRATION_MUTATION = `
  mutation CompleteCalendarReconnectMigration($connectionPublicId: String!, $enableOrphanDeletes: Boolean) {
    completeCalendarReconnectMigration(
      connectionPublicId: $connectionPublicId
      enableOrphanDeletes: $enableOrphanDeletes
    ) {
      result
      errors
      steps
      correlationId
      backfillEnqueued
      wouldDelete
      deleted
      ambiguous
      orphanDryRun
    }
  }
`

export const REFRESH_APPLE_CALENDAR_MIRROR_MUTATION = `
  mutation RefreshAppleCalendarMirror($connectionPublicId: String!) {
    refreshAppleCalendarMirror(connectionPublicId: $connectionPublicId) {
      result
      errors
      retryAfterSeconds
    }
  }
`
